<template>
  <div>
    <hero-alt :src="require(`@/assets/images/IMG_7268.jpg`)" :title="$t('views.about')" />
    <about-our-product/>
    <contact-us/>
    <affiliates/>
    <info />
  </div>
</template>
<script lant='ts'>
import View from "@/views/View";
import LoadSections from "@/mixins/load-sections";
import Component from "vue-class-component";
import Vue from "vue";
import heroAlt from "@/views/sections/HeroAlt.vue";
import KeepInTouch from "@/views/sections/KeepInTouch.vue";
import Info from "@/views/sections/Info.vue";
import AboutOurProduct from "@/views/sections/AboutOurProduct.vue";
import Affiliates from "@/views/sections/Affiliates.vue";
import ContactUs from "@/views/sections/ContactUs.vue";

@Component({
  name: "About",
  extends: View,
  mixins: [LoadSections(["hero-alt", "keep-in-touch", "map", "info"])],
  props: {
    id: {
      type: String,
      default: "about",
    },
  },
  components: {
    heroAlt,
    KeepInTouch,
    Affiliates,
    AboutOurProduct,
    ContactUs,
    Info,
  },
})
export default class About extends Vue {}
</script>
